@let days = payment().termDays;
{{ 'duration.days' | onyxPluralTranslate: days | translate: { days } }}
{{ 'labels.from' | translate | lowercase }}

@if (payment().termType === PaymentTermType.SELECTED_DAY) {
  {{ payment().selectedTermDay }}.
  {{ 'labels.dayOfMonthAfterFinish' | translate | lowercase }}
} @else if (isDayOfWeek()) {
  1.
  {{
    `${DictionaryCode.PAYMENT_TERM_TYPE}.${payment().termType}`
      | translate
      | lowercase
  }}
  {{ 'labels.afterFinish' | translate | lowercase }}
} @else {
  {{
    `${DictionaryCode.PAYMENT_TERM_TYPE}.${payment().termType}`
      | translate
      | lowercase
  }}
}
